import { OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
var ModalRejectGenericComponent = /** @class */ (function () {
    function ModalRejectGenericComponent(dialogRef, data, formBuilder, snackBar) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.formBuilder = formBuilder;
        this.snackBar = snackBar;
        console.log('data', data);
    }
    ModalRejectGenericComponent.prototype.cancel = function () {
        this.dialogRef.close('cancel');
    };
    ModalRejectGenericComponent.prototype.submit = function () {
        if (!this.formGroup.valid) {
            this.snackBar.open("Preencha corretamente os campos e tente novamente.");
            return false;
        }
        this.dialogRef.close(this.formGroup.value.reason);
    };
    ModalRejectGenericComponent.prototype.ngOnInit = function () {
        this.formGroup = this.formBuilder.group({
            reason: [null, [
                    Validators.required,
                ]],
        });
    };
    return ModalRejectGenericComponent;
}());
export { ModalRejectGenericComponent };
